import React, { useEffect } from 'react'
import useFetch from 'use-http'

interface CSRFProviderProps {
  children: React.ReactNode
}

interface CSRFContextProps {
  token: string
  loading: boolean
}

export const CSRFContext = React.createContext<CSRFContextProps>({
  token: '',
  loading: true,
})

const CSRFProviderFetch: React.FC<CSRFProviderProps> = ({
  children,
}: CSRFProviderProps) => {
  const { data, loading } = useFetch<{ token: string }>(
    '/api/csrf/',
    {
      headers: {
        'Content-Type': 'application/json',
        'x-ik-csrf-internal-request-token':
          'lsdjlsdlfo2ekskndfn29839usdkfn23092!QW33@',
      },
    },
    [],
  )
  useEffect(() => {
    if (data?.token) {
      window.csrfToken = data.token
    }
  }, [data])

  return (
    <CSRFContext.Provider value={{ token: data ? data.token : '', loading }}>
      {children}
    </CSRFContext.Provider>
  )
}

export const CSRFProvider: React.FC<CSRFProviderProps> = ({
  children,
}: CSRFProviderProps) => {
  if (window.user?.csrfToken) {
    window.csrfToken = window.user.csrfToken
    return (
      <CSRFContext.Provider
        value={{ token: window.user.csrfToken, loading: false }}
      >
        {children}
      </CSRFContext.Provider>
    )
  }

  return <CSRFProviderFetch>{children}</CSRFProviderFetch>
}
